module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "login"
    }
  }, [_c('h1', [_vm._v("Log in")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Username"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "message"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Not yet a member? "), _c('router-link', {
    staticClass: "font-link floatright",
    attrs: {
      "to": "/account-selection"
    }
  }, [_vm._v("Sign up!")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Become our Supplier")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Post your products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications and feedbacks about your products")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ce0e29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 154
// module chunks = 0